import { useEffect, useState } from 'react';
import { ensure, toggleBusHidden, update as updateBus } from '../store/busesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useModals } from '@mattjennings/react-modal-stack';
import { URL_PREFIX } from '../api';
import ImagePickerModal from '../components/ImagePickerModal';
import { DataContainer } from '../components/DataContainer';
import { fetch } from '../store/busesSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';



function BusModal({ open, id }) {
    id = id.toUpperCase();
    const { closeModal, openModal } = useModals();
    const dispatch = useDispatch();
    const [ name, setName ] = useState('');
    const [ hidden, setHidden ] = useState(false);
    const user = useSelector((state) => state.user.data);

    const _buses = useSelector((state) => state.buses.knownBuses);
    const bus = _buses[id];

    useEffect(() => {(async () => {
        await dispatch(ensure({ id }));
    })()}, []);

    useEffect(() => {
        if(!bus) return;
        setName(bus["bus_name"]);
        setHidden(bus["bus_hidden"]);
    }, [bus]);

    function onSave() {
        dispatch(updateBus({
            id, name
        }));
    }

    async function toggleHidden() {
        const wasHidden = hidden;
        const res = await unwrapResult(await dispatch(toggleBusHidden({ id, hidden: !hidden })));
        if(!res) return;

        closeModal();

        toast.success(`Buss ${wasHidden ? 'nähtavaks tehtud!' : 'peidetud!'}`);
    }

    if(!(id in _buses)) return null;

    if (!open) return null;
  
    return (
        <div className='modal'>
            <div className='container column'>
                <DataContainer actionType={'buses/ensure'} >
                    
                    <div className="column p16 g16">

                        <div className="row g16">
                            <h2 className='grow'>{bus.bus_name}</h2>

                            <button
                                onClick={() => {
                                    dispatch(fetch({ id }));
                                    closeModal();
                                }}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="#666" version="1.1" id="Capa_1" viewBox="0 0 490 490" >
                                    <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
                                </svg>
                            </button>

                        </div>
                        
                        <div className="column g8">
                            <img
                                src={URL_PREFIX + "/storage/bus/"+bus.bus_id.toLowerCase()+".jpg"}
                                style={{ borderRadius: 8, backgroundColor: '#ddd', objectFit: 'contain', height: 240 }}
                            />
                            { user.role == "admin" && (
                                <button onClick={() => openModal(ImagePickerModal, { title: bus.bus_name, url: `/bus/${id}/photo`, callback: () => dispatch(fetch({ id })) })}>Muuda pilti</button>
                            ) }
                            { user.role == "admin" && (
                                <button onClick={toggleHidden} style={hidden ? {} : { backgroundColor: '#d4635b', borderColor: '#f4837b', color: '#fff' }}>
                                    {hidden ? "Too tagasi" : "Peida"}
                                </button>
                            ) }
                        </div>
                    
                    </div>

                    { user.role == "admin" && (
                        <>
                            <div className="hr"></div>
                            
                            <div className="column p32 g16">

                                <h3>Andmed</h3>
                                
                                <DataContainer actionType={'buses/ensure'} >
                                    <div className="column g4">
                                        <b>Nimi</b>
                                        <input type="text" value={name} onChange={e => setName(e.target.value)} />
                                    </div>
                                </DataContainer>

                                <button onClick={onSave}>Salvesta</button>
                            </div>
                        </>
                    ) }
                </DataContainer>
            </div>
        </div>
    );
}

export default BusModal;